import React from 'react'
import Switch from '../switch/Switch';
import Styles from "./MainFrame.module.scss"
import { ReactComponent as EditIcon } from "../../images/icons/edit.svg"

interface MainFrameProps {
  url: string;
  category: string
  isEditing: boolean;
  onEditClick: () => void;
}

const MainFrame = ({ url, category, isEditing, onEditClick }: MainFrameProps) => {

  return (
    <div className={Styles.container}>
      {
        category === "videos"
          ?
          <iframe className={Styles.videoFrame} src={`${url}?autoplay=1&mute=0&modestbranding=1&color=yellow&theme=dark`} title="YouTube video player" allow="fullscreen; accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share" ></iframe>
          :
          <div className={Styles.img} style={{ backgroundImage: `url("${url}")` }} />
      }

      {
        category != "videos" && (
          <div className={Styles.edit_button}>
            <div className={Styles.edit_container}>
              <Switch isChecked={isEditing} onChange={onEditClick} name={"edit"} icon={<EditIcon />} showLabel={false} />
            </div>
          </div>
        )
      }
    </div>
  )
}

export default MainFrame
